<template>
  <div class="app-main-content">
    <subscribe-list subscribe-name="PA" />
  </div>
</template>

<script>
import SubscribeList from '@/views/cargo/v0/Price/components/list/subscribeList'
export default {
  name: 'PriceAirSubscribe',
  components: { SubscribeList }
}
</script>

<style scoped>

</style>
